export default __webpack_public_path__ + "static/monetisation-9a075677ade9d1c062a5682514a22bc8.png";